import { RuntimeModelField } from '@kunlun/dependencies';

export type UnwrapPromise<T> = T extends Promise<infer U> ? U : T;

export enum ErrorCode {
  OTHER = 'OTHER'
}

export class ValidateExcelError extends Error {
  private errorCode: ErrorCode;

  constructor(errorCode: ErrorCode, message: string) {
    super();
    this.message = message;
    this.errorCode = errorCode;
  }
}

export interface ExcelModelField extends RuntimeModelField {
  excelLabel: string;
}

export interface SelectOption<T = string> {
  label: string;
  value: T;
}

export interface EnhancedSelectOption<T = string> extends SelectOption<T> {
  name: string;
  displayName: string;
}
